import React from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap'

export const FieldGroup = ({ id, label, value = '', type = "text", onChange, className, children, ...props }) => (
  <FormGroup className={className} controlId={id}>
    <ControlLabel>{!props['data-optional'] ? '*' : ''}{label}</ControlLabel>
    {children}
    <FormControl type={type} value={value} onChange={onChange} {...props} />
  </FormGroup >
)
